//********************* GET ORG CONTACTS ********************************//
// Flattens and dedupes a user's sharing-group members into a single list of
// candidates, resolving each id via gudhub.getUserById and excluding anyone
// in excludeIds. Shared by the "Add people" picker and the call-profile
// contact picker.
//
// Deliberately NOT computed from getWorkspaceUsers()'s `groups` field:
// sharing groups routinely include people outside the caller's own workspace
// (e.g. clients in another company) - measured on a real group, ~3/4 of its
// members were missing from the workspace list entirely. getUsersByGroup
// stays the source of truth for membership; gh_conversation.js's one-time
// getUserWorkspace() prefetch still saves most of the getUserById calls below
// by warming the cache for whichever candidates ARE in the workspace.
// * activeUserId (string|number) — GudHub user id whose sharing groups to read
// * excludeIds (Array<string|number>) — ids to leave out
export async function getOrgContacts(activeUserId, excludeIds) {
    const groups = await gudhub.groupSharing.getGroupsByUser(activeUserId);
    if(!groups?.length) return [];

    const groupUsersLists = await Promise.all(groups.map(group => gudhub.groupSharing.getUsersByGroup(group.group_id)));

    const excludeSet = new Set(excludeIds.map(String));
    const candidateIds = new Set();

    for(const groupUsers of groupUsersLists) {
        for(const groupUser of groupUsers || []) {
            const userId = String(groupUser.user_id);
            if(!excludeSet.has(userId)) candidateIds.add(userId);
        }
    }

    const users = await Promise.all([...candidateIds].map(id => gudhub.getUserById(id)));

    return users.filter(Boolean).sort((a, b) => (a.fullname || '').localeCompare(b.fullname || ''));
}
